<template>
  <el-row style="margin: 1.25rem;">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-row >
      <el-col :span="16" :offset="4" v-if="show=='true'" >
        <el-row style="text-align: center;">
          <h2>{{list.name}}</h2>
        </el-row>
        <el-card class="box-card" v-for="(item,index) in list.content" :key="index" style="margin-top: 1.25rem;">
          <div slot="header" class="clearfix">
            <span><span style="margin-right: 0.3125rem;font-size: 0.9375rem;">{{index+1}}.</span>{{item.name}}</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <el-row v-if="item.type=='input'">
            <el-input  disabled  v-model="item.user_choice" placeholder="请输入内容" @input="elinput()"></el-input>
          </el-row>
          <el-row v-else v-for="(items,indexs) in item.choice" :key="indexs" class="text item" >
            <el-radio-group v-if="item.type=='radio'"  v-model="item.user_choice">
                <el-radio disabled :label="items.num"  >{{items.name}}</el-radio>
              </el-radio-group>
            <el-checkbox-group v-else v-model="item.user_choice">
                <el-checkbox disabled :label="indexs">{{items.name}}</el-checkbox>
              </el-checkbox-group>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

  </el-row>
</template>

<script>
  import load from "../../../../components/load.vue"
  export default {
      data() {
        return {
          num:this.$route.query.num,
          list:{},
          input:'',
          liad_show:false,
          show:false,
          }
        },
        components: {
          load:load
         },
        mounted: function (){
            this.get_see_info()

        },
        methods: {
          get_see_info(){
            let _this=this
            _this.liad_show=true
            _this.show=false
            _this.axios.get('/v2/c_investigate/investigate_push_companyee_exam', {
                params: {
                  num:_this.num
                }
              }).then(function(res) {
                if (res.status == '200') {
                  if (res.data.code == '1') {
                    _this.liad_show=false
                    _this.show='true'
                    _this.list.name=res.data.data.name
                    _this.list.content=res.data.data.exam
                    for(let i=0;i<_this.lisl.content.length;i++){
                      if( _this.list.content[i].hasOwnProperty('choice')){
                        for(let j=0;j<_this.list.content[i].choice.length;j++){
                          _this.list.content[i].choice[j]['num']=j
                        }
                      }
                    }
                  } else {
                    _this.$message.error(res.data.msg)
                  }
                } else {
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                // _this.$message.error('服务器内部错误')
              });
          },


      }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_data/see.vue